jQuery.noConflict();

(function($) {

    $(function($){

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;


        $(document).find('*[data-fancybox]').fancybox({
            fitTiView: true
        });

        Number.prototype.format = function(n, x, s, c) {
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
                num = this.toFixed(Math.max(0, ~~n));
        
            return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
        };


        $('.tablesorter').tablesorter();
        
        function a5_print() {
            var u=location.href; 
            var t="A5 print"; 
            window.open(window.location.href + '?print=A5', "sharer", "toolbar=0,scrollbar=yes,status=0,width=530,height=764"); 
            return false;
        }
									

        $('.print-trigger').on('click', function (e) {
            e.preventDefault();
            //console.log(e.shiftKey); 
            if (e.shiftKey) {
                $('body').data('print', 'A5');
                $('body').attr('print', 'A5');
                $('body').addClass('format-A5');
                $('body').removeClass('format-A4');
                /*var u=location.href; 
                var t="A5 print"; 
                window.open(window.location.href, "sharer", "toolbar=0,scrollbar=yes,status=0,width=530,height=764");
                return false;*/
                //return a5_print();
                //window.open();
            } else {
                $('body').data('print', 'A4');
                $('body').attr('print', 'A4');
                $('body').addClass('format-A4');
                $('body').removeClass('format-A5');
            }
            return window.print();
        });


        (function () {

            /*var beforePrint = function () {
                alert('Functionality to run before printing.');
            };
    
            var afterPrint = function () {
                alert('Functionality to run after printing');
            };
    
            if (window.matchMedia) {
                var mediaQueryList = window.matchMedia('print');
    
                mediaQueryList.addListener(function (mql) {
                    //alert($(mediaQueryList).html());
                    if (mql.matches) {
                        beforePrint(); 
                    } else {
                        afterPrint();
                    }
                });
            }
    
            window.onbeforeprint = beforePrint;
            window.onafterprint = afterPrint;*/
    
        }());

        window.onbeforeprint = function() {
            console.log('This will be called before the user prints.');
        };
        window.onafterprint = function() {
            console.log('This will be called after the user prints');   
        };
        //console.log($(document).find('.image-content > img')[0].height());

        (function () {
            const $mainFilter = $('#property-search-form');
            const $wrapFilter = $('#wrapper-filter');
            let val;
            
            $wrapFilter.on('change', '#property-search-form', function (e) {
                var $target = $(e.target);
                //console.log($target.is('select'));
                console.log(e);
                console.log(e.delegateTarget);
                console.log($target.is('select'));
                if(!$target.is('select')) return;
                //Form on change event
                $.ajax({
                    url: localize.ajaxurl + '?action=refreshfilter',
                    method : 'GET',
                    beforeSend : function() {
                        $wrapFilter.addClass('loading');
                    },
                    data : $(this).serializeArray(),
                  }).done(function(data) { 
                        $wrapFilter.html(data).removeClass('loading');
                        //console.log($wrapFilter.find($target));
                        //$target.parent('fieldset').trigger('focus');
                  });
            });


            $('#property-order').on('change', function () {
                val = $(this).val();
                $('#sort-control').val(val);
                $mainFilter.trigger('submit');
            });

            $('.property-layout').on('change', function () {
                val = $(this).val();
                $('#layout-control').val(val);
                $mainFilter.trigger('submit');
            });
        })();
        (function () {
            const $relatedForm = $('#related-controls');
            $relatedForm.on('change', function () {
                //relatedForm
                $(this).trigger('submit');
            });  
        })();

        //Initial load - draws map and calls drawMarketsOnMap
        (function() {
            let $map = $('#map');
            if ($map.length > 0) {
                window.propertiesMap = new GMaps({
                    div: '#map',
                    lat: 46.554649,
                    lng: 15.645881,
                    zoom: isMobile ? 8 : 10
                });

                if($map.data('address')) {
                    drawCurrentMap();
                } else {
                    drawAllMarkers();
                }
            }
        })();
        function drawCurrentMap() {

            let $map = $('#map');
            var map = window.propertiesMap;
            GMaps.geocode({
                lat: pdata.GPS_lan,
                lng: pdata.GPS_lon,
                address: pdata.loc,
                callback: function(results, status) {
                  if (status == 'OK') {
                    var latlng = results[0].geometry.location;
                    window.propertiesMap.setZoom(12);
                    window.propertiesMap.setCenter(latlng.lat(), latlng.lng());
                    window.propertiesMap.drawCircle({
                        strokeColor: "#FF0000",
                        strokeOpacity: 0.6,
                        strokeWeight: 5,
                        fillColor: "#FFFFFF",
                        fillOpacity: 0,
                        center: latlng,
                        radius: Math.sqrt(100) * 100
                    });
                  }
                }
              });
        }


        function drawAllMarkers() {
            if(typeof ajaxProperties !== 'undefined') {

                for (const property of Object.values(ajaxProperties)) {
                    drawMarketsOnMap(property);
                }

            }
        }

        (function () {
            
                let activeFilter;
                let $filterBtn = $('#map-filters .filter-btn');
                $filterBtn.on('click', function (e) {
                    e.preventDefault();
                    window.propertiesMap.removeMarkers();
                    $filterBtn.removeClass('active');
                    $(this).addClass('active');
                    activeFilter = $(this).data('id');
                    if (activeFilter === 0) {
                        drawAllMarkers()
                    } else {
                        drawMarketsOnMap(ajaxProperties[activeFilter], true);
                    }
                });
           
        })();

        //Draw markers, register click events, etc.
        function drawMarketsOnMap(properties, shouldFit= false) {

            if (!properties || properties.length < 1) {
                return false;
            }

            var locationBounds = [
                {
                    lat: 46.554649,
                    lng: 15.645881
                }
            ];
            let content;
            properties.forEach(function(property) {
                content = property.map_item;

                if(property.lat && property.lng) {
                    var singleLocation = {
                        lat: parseFloat(property.lat),
                        lng: parseFloat(property.lng)
                    };

                    if (shouldFit) {
                        locationBounds.push(singleLocation);
                    }

                    window.propertiesMap.addMarker({
                        lat: property.lat,
                        lng: property.lng,
                        title: property.name,
                        infoWindow: {
                            content: property.map_item,
                            zIndex: -1,
                            maxWidth: 255,
                            minWidth: 255
                        },
                        icon: {
                            url: property.icon
                        },

                    });
                }

            });

            // if (shouldFit) {
            //     window.propertiesMap.fitLatLngBounds(locationBounds);
            // }
        }


        //jQuery('[data-owl-options]').data('owl-options')


        //$('.owl-carousel').slick();


        if($('#wrapper-slider').length > 0) {

            $(".owl-carousel").owlCarousel(
                {
                    loop: true,
                    nav: true,
                    center: true,
                    dots: true,
                    singleItem : true,
                    autoPlay: true
                }
            );

        } else
        if($('.custom-nav').length > 0) {
            
            $(".owl-carousel").owlCarousel(
                {
                    loop: true,
                    nav: true,
                    center: true,
                    items: 1,
                    dotsContainer: '#carousel-custom-dots',
                    navContainer: $('.custom-nav'),
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    navText: ["<img class='arrow-previous' src='/wp-content/themes/emigma/assets/svg/arrow.svg'>", "<img src='/wp-content/themes/emigma/assets/svg/arrow.svg'>"],
                }
            );
        } else if($(".owl-carousel").length > 0) {

            var $OC = $(".owl-carousel");
            var options = $OC.data('wp-options');

            //console.log(options);

            //$OC.owlCarousel(); 

            if( typeof options === 'object') {

                //console.log(options);
                /* owl carousel options from HTML */
                var	_autoplay 			= ( 'yes' === options.autoplay ) ? true : false,
					_nav 		        = ( 'yes' === options.nav ) ? true : false,
					_dots 		        = ( 'yes' === options.dots ) ? true : false,
					_speed 				= ( options.speed!==undefined ) ? options.speed : 500,
                    _items 				= ( options.items!==undefined ) ? options.items:1,
                    _margin 			= ( options.margin!==undefined ) ? options.margin:0,
                    _stagepadding 	    = ( options.stagePadding!==undefined ) ? options.stagePadding:0,
					_tablet 			= ( options.tablet!==undefined ) ? options.tablet:1,
					_mobile 			= ( options.mobile!==undefined ) ? options.mobile:1;

                $OC.owlCarousel(
                    {
                        //loop: true,
                        //center: false,
                        items: _items,
                        margin: _margin,
                        stagePadding: _stagepadding,
                        nav: _nav,
                        dots: _dots,
                        autoplay: _autoplay,
                        autoplaySpeed: _speed,
                        responsiveClass: true,
                        animateOut: 'fadeOut',
                        animateIn: 'fadeIn',
                        /*responsive: {
                            0: {
                                items: _mobile,
                            },
                            480: {
                                items: _tablet,
                            },
                            999: {
                                items: _items,
                            }
                        }*/
                    }
                );
            }

        }

        /*$('.owl-dot').on('click', function () {
            $(".owl-carousel").trigger('to.owl.carousel', [$(this).index(), 300]);
        });*/

        $('#emi-notice').on('closed.bs.alert', function () {
            setCookie('hideNotice', true, 1);
        });


        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }



        //These will be updated on window.resize
        //If you want an element to have any of its properties
        //calculated dynamically, please push it to this array in object format
        //Structure of object should be:
        /*
        {
            'element': $('#element'),
            'property': 'padding-left',
            'callback': calcFluidPadding
        }
        */
        let dynamicElements = [];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }

        (function() {
            var $frame = $('.frame');
            if ($frame.length !== 0) {
                new Sly($frame, {
                    horizontal: 1,
                    itemNav: 'forceCentered',
                    activateMiddle: 1,
                    smart: 1,
                    activateOn: 'click',
                    mouseDragging: 1,
                    touchDragging: 1,
                    releaseSwing: 1,
                    startAt: 1,
                    scrollBy: 1,
                    activatePageOn: 'click',
                    speed: 200,
                    moveBy: 600,
                    elasticBounds: 1,
                    dragHandle: 1,
                    dynamicHandle: 1,
                    clickBar: 1,
                    // Navigation buttons
                    forward:  null, // Selector or DOM element for "forward movement" button.
                    backward: null, // Selector or DOM element for "backward movement" button.
                    prev:     $('.btn.prev'), // Selector or DOM element for "previous item" button.
                    next:     $('.btn.next'), // Selector or DOM element for "next item" button.
                    scrollBar: $('.o-scrollbar')
                }).init();
            }
        })();

        (function() {
            $('.owl-dot a').on('click', function(e) {
                if(!$(this).parent().hasClass('active')) {
                    e.preventDefault();
                }
            });
        })();

        $(window).on('resize', function () {
            updateDynamicElements();
        });


        function calcFluidPadding() {
            let $container = $('.container');
             return ($( 'body' ).width() - $container.width()) / 2;
        }


        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.main-navigation'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
            $('#ar-language-switcher').toggleClass('show');
        });


        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }

        /*
        ******************************************************************************************************
            Tables
        ******************************************************************************************************
        */

        $('#content').find('table').each(function(i, el){
            $(el).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    if($(table).parent().is(':not(.table-responsive)')) {
                        return $(table).wrap('<div class="table-responsive"></div>');
                    }
                });
            }
        })();




        (function () {


                $('#exchange').on('change', function(ee){
                        
                    if($('.currency-select').val() !== '' && $("#from_select").val() === $("#to_select").val()) {

                        alert($(this).data('warning'));
                        return $('.currency-select').prop('selectedIndex', 0);
    
                    }


                });

                let final_value = 0;
                let final_start = 0;
                let final_code = '';
                $('#exchange').on('input', function(e){

                    $('#final_value').text('');
                    $("#final_from").text('');
                    $("#final_to").text('');
                    $('#final_start').text('');
                    
                    if($("#from_select > option:selected").text() === $("#to_select > option:selected").text()) {
                        //not allowing user to select same currency
                        
                        return false;
                    } else if($("#from_value").val() && $("#from_select").val() && $("#to_select").val()) {

                        if($("#from_select > option:selected").text()) {
                            $("#final_from").text($("#from_select > option:selected").data('code') + ' je');
                        } 
                       
                        if($("#to_select > option:selected").text()) {
                            $("#final_to").text($("#to_select > option:selected").data('code'));
                        } 

                        final_start = $("#from_value").val();

                        $('#final_start').text(formatMoney(final_start, 2, ',', '.'));
                        //$('#final_start').text(final_start.format(2, 3, '.', ','));
                         
                        final_value = Math.round($("#from_value").val() * $("#to_select").val() / $("#from_select").val() * 100) / 100;
                        final_code = $("#to_select > option:selected").data('code');


                        //return  $("#final_value").text(new Intl.NumberFormat('de-DE', { style: 'currency', currency: final_code }).format(final_value));
    
                        //final event
                        //return $("#final_value").text(final_value.format(2, 3, '.', ','));
                        return $("#final_value").text(formatMoney(final_value, 2, ',', '.'));
                    }


                    /*const number = 123456.789;
                    console.log();*/
                    
                });


                function formatMoney(number, decPlaces, decSep, thouSep) {
                    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
                    decSep = typeof decSep === "undefined" ? "." : decSep;
                    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
                    var sign = number < 0 ? "-" : "";
                    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
                    var j = (j = i.length) > 3 ? j % 3 : 0;
                
                    return sign +
                        (j ? i.substr(0, j) + thouSep : "") +
                        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
                        (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
                }



                
                
                
        })();



        (function () { 


            $('#property-search-form').on('submit', function(e){
                console.log(e);
                $(this).find(':input').each(function(i, el){

                    if($(el).val() === '') {
                        $(el).attr('disabled', true);
                    }
                    
                });
                //return false;
            });

            $('#property-search-form').find('select').each(function(i, el){

                    if($(el).val() === '') {
                        $(el).addClass('invalid');
                        $(el).removeClass('valid');
                    } else {
                        $(el).addClass('valid');
                        $(el).removeClass('invalid');
                    }
            });
                /*$('#property-search-form').on('input', function(e){
                        if($(e.target).val() === ''){
                            $(e.target).trigger('property.invalid');
                        } else {
                            $(e.target).trigger('property.valid');
                        }
                });*/


                $('#property-search-form').on({

                    'input' : function(e) {

                        if($(e.target).val() === '') {
                            $(e.target).addClass('invalid');
                            $(e.target).removeClass('valid');
                        } else {
                            $(e.target).addClass('valid');
                            $(e.target).removeClass('invalid');
                        }
                    },
                    'property.invalid' : function(e) {
                            console.log(e);
                            $(e.target).addClass('invalid');
                            $(e.target).removeClass('valid');

                    },
                    'property.valid' : function(e) {
                        console.log(e);
                        $(e.target).addClass('valid');
                        $(e.target).removeClass('invalid');

                    },
                    /*'property.init' : function(e) {
                        console.log(e);
                        $(e.target).addClass('valid');
                        $(e.target).removeClass('invalid');

                    }*/

                });


                $('select').each(function(i, el){

                   $(el).on('change', function(e){

                    console.log($(this).val());
                        
                   });
                   //$(this).trigger('change');

                });



        })();

        (function() {

            $( ".property-slide-ranger" ).each(  function(){

                var _this = this;
                var unit = $(this).data( "unit" );
                var decimals = $(this).data( "decimals" );
                var min = $( '.slide-ranger-bar', this ).data('min');
                var max = $( '.slide-ranger-bar', this  ).data('max');

                var imin = $( '.slide-ranger-min-input', this ).val();
                var imax = $( '.slide-ranger-max-input', this ).val();
                var p_slider = $(".slide-ranger-bar", this).get(0);
                var unit_pos = $(this).data( "unitpos" );
                var thousand = $(this).data( "thousand" );

                var config_format = {
                    decimals: decimals,
                    thousand: thousand,
                };

                if(unit_pos == 'prefix'){
                    config_format.prefix = ' ' + unit + ' ';
                }else{
                    config_format.postfix = ' ' + unit + ' ';
                }

                var nummm = wNumb(config_format);

                noUiSlider.create(  p_slider, {
                    range: {
                      'min': [ min ],
                      'max': [ max ]
                    },
                    //start: [60000, 80000],
                    connect: true,
                    start: [imin, imax],
                    format: nummm,
                    //direction: 'ltr',

                });
                p_slider.noUiSlider.on('update', function( values, handle ) {

                    var val = values[handle];

                    if( handle == 0 ){
                        $(".slide-ranger-min-label", _this).text(val);
                        $(".slide-ranger-min-input", _this).val( nummm.from(val)  );
                    }else{
                        $(".slide-ranger-max-label", _this).text(val);

                        $(".slide-ranger-max-input", _this).val( nummm.from(val) );
                    }
                });

                p_slider = null;

           } );


          })();

        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        (function(){
            $('*[data-toggle="tooltip"]').tooltip();
        })();

        //language switcher
        (function () {
            /*
            ******************************************************************************************************
              Language switcher controls
            ******************************************************************************************************
            */
            // Reverse function df
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len =   this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        }  else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

            $(document).on('click', '[data-toggle="lightbox"]', function(event) {
                event.preventDefault();
                $(this).ekkoLightbox({
                    'alwaysShowClose': true,
                    'scale_height':true
                });
            });



            $(".open-lightbox").on('click', function(e) {
                e.preventDefault();
                $(".second-gallery a").first().trigger('click');
            });

            $(".form-select").on('change', function() {
                var selectedID = $(this).find(":selected").val();
                $(".forms .form").css("display", "none");
               $(".forms .form-" + selectedID).css("display", "block");
            });



            $(".overlay").on('click', function() {
                $(this).removeClass('active');
            });


        })();

    });





})( jQuery );
